// extracted by mini-css-extract-plugin
export default {"tabPane":"tabPane_tabPane__0BGF6"};